module.exports = __webpack_public_path__ + "static/media/bigger-than-ourselves.45d9f364.png";